import * as React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import DevFlag from 'common/components/DevFlag';
import Campaign from 'common/modules/campaign/domain/Campaign';
import ConfirmationDialog from 'common/components/ui/ConfirmationDialog';
import CampaignAPI from '../services/CampaignAPI';
import { getStation, getToken } from '../../authentication/session/selectors/sessionSelectors';
import Permissions from '../../authorisation/Permissions';
import AuthorisedComponent from '../../authorisation/AuthorisedComponent';
import { CampaignInFolloStatus } from '../domain/CampaignInFolloStatus';

export const BUTTON_ID = 'activate-campaign-in-follo-button';

interface Props {
  t: (key: string) => key;
  token: string;

  campaign: Campaign;
}

interface State {
  showConfirmationDialog: boolean;
  folloStatus?: CampaignInFolloStatus;
}

export class ActivateCampaignInFolloButton extends React.Component<Props, State> {
  state = {
    showConfirmationDialog: false,
    folloStatus: undefined,
  }

  async componentDidMount() {
    await this.fetchFolloStatus();
  }

  fetchFolloStatus = async () => {
    const { token, callSign, campaign } = this.props;
    const folloStatus = await CampaignAPI.verifyIfCampaignIsActivatedInFollo(token, callSign, campaign.reference);
    this.setState({ folloStatus });
  }

  onActivateCampaignInFollo = async () => {
    const { token, callSign, campaign } = this.props;
    await CampaignAPI.activateInFollo(token, callSign, campaign.reference);
    this.closeDialog();
    await this.fetchFolloStatus();
  };

  renderMarkdown(markdown: string) {
    return <ReactMarkdown source={markdown} />;
  }

  openDialog = () => this.setState({ showConfirmationDialog: true });
  closeDialog = () => this.setState({ showConfirmationDialog: false });

  render() {
    const { campaign, t } = this.props;
    const { showConfirmationDialog, folloStatus } = this.state;

    if (!folloStatus || folloStatus.existsInFollo) {
      return null;
    }

    const otherConfirmationProps = {};
    if (!folloStatus.customerHasAccessToFollo) {
      otherConfirmationProps.message = this.renderMarkdown(t('activateCampaignInFolloForCustomerWithoutFolloAccess', { customerName: campaign.customer.name }));
    }

    return (
      <DevFlag flag="FOLLO_WITHOUT_FOLLO">
        <AuthorisedComponent permissions={Permissions.MANAGE_CAMPAIGNS}>
          <RaisedButton id={BUTTON_ID} primary label={t('activateCampaignInFolloButton')} onClick={this.openDialog} />
          <ConfirmationDialog
            action={t('activateCampaignInFolloAction')}
            open={showConfirmationDialog}
            onConfirm={this.onActivateCampaignInFollo}
            onCancel={this.closeDialog}
            {...otherConfirmationProps}
          />
        </AuthorisedComponent>
      </DevFlag>
    );
  }
}

function mapStateToProps(state, ownProps: Props) {
  return {
    token: getToken(state),
    callSign: getStation(state),
  };
}

export default translate('campaigns')(connect(mapStateToProps)(ActivateCampaignInFolloButton));




// WEBPACK FOOTER //
// ./src/statsradio/modules/campaigns/components/ActivateCampaignInFolloButton.js